let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gialu"), load("4CfTY"), load("gctwz"), load("4drdS"), load("dezv5")]).then(() => parcelRequire('hD4yV'));